<div class="c-dialog-template-icon"
  [ngClass]="[
    color ? 'c-dialog-template-icon--color-' + (color | toCssClassName) : ''
  ]">
  <app-bui-icon
    [name]="name">
  </app-bui-icon>
</div>
